import InfiniteScroll from './infinite-scroll.element.js';

export default InfiniteScroll;

InfiniteScroll.define('wje-infinite-scroll', InfiniteScroll);
